import { useParams } from "react-router-dom";

interface PathParams {
    agreementId: string
}

export const useAgreementId = () => {
    return useParams<PathParams>();
}